import { Component } from '@theme/component';
class HexoSearch extends Component {
  #controller;
  #request;
  #timer;
  #generation=0;
  #supportsPredictive=false;
  connectedCallback() {
    super.connectedCallback();
    this.#controller?.abort();
    this.#controller=new AbortController();
    try {
      this.#supportsPredictive=JSON.parse(document.getElementById('shopify-features')?.textContent || '{}').predictiveSearch === true;
    } catch { this.#supportsPredictive=false; }
    this.querySelector('input[type=search]')?.addEventListener('input',this.#input,{signal:this.#controller.signal});
    this.closest('dialog')?.addEventListener('close',()=>this.#cancel(),{signal:this.#controller.signal});
    this.closest('dialog')?.addEventListener('hexo:dialog-open',this.#input,{signal:this.#controller.signal});
  }
  disconnectedCallback(){super.disconnectedCallback();this.#controller?.abort();this.#cancel();}
  #cancel(){
    clearTimeout(this.#timer);this.#request?.abort();this.#generation++;
    const results=this.querySelector('[data-hx-search-results]');
    results?.removeAttribute('aria-busy');
    results?.replaceChildren();
  }
  #input=()=>{
    this.#cancel();
    const query=this.querySelector('input[type=search]').value.trim(),results=this.querySelector('[data-hx-search-results]');
    if(!results)return;
    if(query.length<2)return;
    if(!this.#supportsPredictive){results.textContent=this.dataset.fallback;return;}
    this.#timer=setTimeout(()=>this.#search(query),250);
  };
  async #search(query){
    const generation=this.#generation,results=this.querySelector('[data-hx-search-results]');
    this.#request=new AbortController();
    results.setAttribute('aria-busy','true');
    results.textContent=this.dataset.loading;
    try{
      const url=new URL(this.dataset.suggestUrl,location.origin);
      url.search=new URLSearchParams({q:query,'resources[type]':'product,page,article,collection','resources[limit]':'6','resources[options][fields]':'title,product_type,variants.title,variants.sku,body'});
      const response=await fetch(url,{signal:this.#request.signal});
      if(response.status===417)this.#supportsPredictive=false;
      if(!response.ok)throw new Error('Search unavailable');
      const data=await response.json();
      if(generation!==this.#generation)return;
      results.replaceChildren();
      const resources=data.resources?.results||{};
      const matches=[...(resources.products||[]),...(resources.pages||[]),...(resources.articles||[]),...(resources.collections||[])].slice(0,8);
      if(!matches.length){const p=document.createElement('p');p.textContent=this.dataset.empty;results.append(p);}
      for(const item of matches){
        const target=new URL(item.url,location.origin);
        if(target.origin!==location.origin)continue;
        const link=document.createElement('a');link.href=target.href;link.textContent=item.title;results.append(link);
      }
    }catch(error){if(error.name==='AbortError'||generation!==this.#generation)return;results.textContent=this.dataset.fallback;}
    finally {if(generation===this.#generation)results.removeAttribute('aria-busy');}
  }
}
if(!customElements.get('hexo-search'))customElements.define('hexo-search',HexoSearch);
